import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ENDPROCESS, PAGETYPE } from 'src/app/core/enums/enums';

@Injectable({ providedIn: 'root' })
export class FinalProcessGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    const endProcessOnSalesForce: boolean = JSON.parse(
      window.sessionStorage.getItem(ENDPROCESS.endProcessOnSalesForce)
    );

    if (endProcessOnSalesForce) {
      this.router.navigate([PAGETYPE.endProcess]);
      return false;
    } else {
      return true;
    }
  }
}
